import { slotDefinition } from "slotworks/model/slot-definition";
import { SymbolMatchType } from "slotworks/model/symbol-definition";

export function ThemeGameDefinitionSetup(): void {
    slotDefinition.matrixGrid = [3, 3, 3,3];
    slotDefinition.processSymbols([
        { 
            id: "X2X3",
            bonusId: 2,
            payouts: {},
            anticipationMatchIds: [7, 8],
            matchType: SymbolMatchType.LINES,
            anticipation: new Map<string, number>([
                [ 'Base', 2 ],
                [ 'Feature1', 2 ],
            ]),
            triggerCounts: new Map<string, number[]>([
                [ 'Base', [3, 4] ],
                [ 'Feature1', [3, 4] ],
            ]),
            reels: [1, 2, 3, 4],
            possibleMatchesPerReel: 1
        }, // 0
        { 
            id: "H1",
            bonusId: 3,
            payouts: {},
            anticipationMatchIds: [1, 7, 8],
            requiredSymbolIds: [7, 8],
            numRequiredSymbols: 2,
            matchType: SymbolMatchType.LINES,
            anticipation: new Map<string, number>([
                [ 'Base', 2 ],
                [ 'Feature1', 2 ],
            ]),
            triggerCounts: new Map<string, number[]>([
                [ 'Base', [3, 4] ],
                [ 'Feature1', [3, 4] ],
            ]),
            reels: [1, 2, 3, 4],
            possibleMatchesPerReel: 1
        }, // 1
        { 
            id: "H2",
            bonusId: 4,
            payouts: {},
            anticipationMatchIds: [2, 7, 8],
            requiredSymbolIds: [7, 8],
            numRequiredSymbols: 2,
            matchType: SymbolMatchType.LINES,
            anticipation: new Map<string, number>([
                [ 'Base', 2 ],
                [ 'Feature1', 2 ],
            ]),
            triggerCounts: new Map<string, number[]>([
                [ 'Base', [3, 4] ],
                [ 'Feature1', [3, 4] ],
            ]),
            reels: [1, 2, 3, 4],
            possibleMatchesPerReel: 1
        }, // 2
        {
            id: "H3",
            bonusId: 5,
            payouts: {},
            anticipationMatchIds: [3, 7, 8],
            requiredSymbolIds: [7, 8],
            numRequiredSymbols: 2,
            matchType: SymbolMatchType.LINES,
            anticipation: new Map<string, number>([
                [ 'Base', 2 ],
                [ 'Feature1', 2 ],
            ]),
            triggerCounts: new Map<string, number[]>([
                [ 'Base', [3, 4] ],
                [ 'Feature1', [3, 4] ],
            ]),
            reels: [1, 2, 3, 4],
            possibleMatchesPerReel: 1
        }, // 3
        {
            id: "H1H2H3",
            bonusId: 6,
            payouts: {},
            anticipationMatchIds: [1, 2, 3, 7, 8],
            requiredSymbolIds: [7, 8],
            numRequiredSymbols: 2,
            matchType: SymbolMatchType.LINES,
            anticipation: new Map<string, number>([
                [ 'Base', 2 ],
                [ 'Feature1', 2 ],
            ]),
            triggerCounts: new Map<string, number[]>([
                [ 'Base', [3, 4] ],
                [ 'Feature1', [3, 4] ],
            ]),
            reels: [1, 2, 3, 4],
            possibleMatchesPerReel: 1
        }, // 4
        { id: "BL",
            payouts: {},
            isBlank: true,
        }, // 5
        {
            id: "BO",
            bonusId: 1,
            matchType: SymbolMatchType.SCATTER,
            anticipation: new Map<string, number>([
                [ 'Base', 2 ],
                [ 'Feature1', 2 ],
            ]),
            triggerCounts: new Map<string, number[]>([
                [ 'Base', [3, 4] ],
                [ 'Feature1', [2, 3, 4] ],
            ]),
            payouts: {},
            reels: [1, 2, 3, 4],
            possibleMatchesPerReel: 1
        }, // 6
        { id: "X3",
            payouts: {}
        }, // 7
        { id: "X2",
            payouts: {},
        }, // 8
    ]);
    slotDefinition.processReelSets({
        base: [
            [5, 2, 5, 6, 5, 3, 5, 8, 5, 1, 5, 8, 5, 3, 5, 1, 5, 6, 5, 2, 5, 3],
            [5, 2, 5, 6, 5, 1, 5, 7, 5, 3, 5, 2, 5, 1, 5, 6, 5, 2, 5, 7, 5, 3],
            [5, 3, 5, 6, 5, 1, 5, 3, 5, 2, 5, 7, 5, 3, 5, 6, 5, 1, 5, 7, 5, 2],
            [5, 1, 5, 8, 5, 2, 5, 8, 5, 3, 5, 6, 5, 2, 5, 3, 5, 6, 5, 1, 5, 2]
        ]
    });
}
